/**
 * Type of this widget.
 */
export const type = 'filter.panel';
